<button
  class="btn btn-sm btn-circle btn-clear btn-untextured btn-ghost text-lg"
  appSfx="ui-error"
  [sfxTrigger]="['click', 'hover']"
>
  <app-icon name="tablerX"></app-icon>
</button>
